import { useState } from 'react'

import { ExportDirectLinkModal } from '../../../Export'

export function useReportTableExport({ entityId, onCheckTask, onStartExport }) {
  const [modal, setModal] = useState(null)

  function handleCloseModal() {
    setModal(null)
  }

  function handleClickExport() {
    setModal(
      <ExportDirectLinkModal
        subjectId={entityId}
        onCancel={handleCloseModal}
        onCheckTask={onCheckTask}
        onClose={handleCloseModal}
        onStartExport={onStartExport}
      />
    )
  }

  return { handleClickExport, modal }
}
